const Image = ({ src, className = "", style = {}, alt }) => {
  return <img src={src} className={className} alt={alt} style={style} />;
};

export default Image;
